export default "__VITE_ASSET__BcUUTare__"